/**
 * Key model translations
 *
 * Translation keys follow the pattern: models.key.{category}.{key}
 * Categories: fields, tabs, blocks, badges, actions, filters, options
 */
export default {
  en: {
    singular: "Key",
    plural: "Keys",

    tabs: {
      general: "General",
      security: "Security",
      history: "History",
    },

    blocks: {
      identity: "Identity",
      client: "Client",
      metadata: "Metadata",
      security_code: "Security Code",
      security: "Security",
      assignment: "Current Assignment",
      notes: "Notes",
    },

    fields: {
      code: "Code",
      name: "Name",
      security_code: "Security Code",
      effective_security_code: "Effective Security Code",
      status: "Status",
      notes: "Notes",
      client_id: "Client",
      created_at: "Created At",
      updated_at: "Updated At",
      client: {
        name: "Client",
      },
      currentAssignment: {
        user: {
          display_name: "Assigned To",
        },
        assigned_at: "Assigned At",
      },
    },

    badges: {
      active: "Active",
      lost: "Lost",
      deactivated: "Deactivated",
    },

    filters: {
      status: "Status",
      client_id: "Client",
    },

    options: {
      status: {
        active: "Active",
        lost: "Lost",
        deactivated: "Deactivated",
      },
    },

    actions: {
      assign: "Assign",
      unassign: "Unassign",
      assign_keys: "Assign Keys",
      unassign_keys: "Unassign Keys",
    },
  },

  fr: {
    singular: "Clé",
    plural: "Clés",

    tabs: {
      general: "Général",
      security: "Sécurité",
      history: "Historique",
    },

    blocks: {
      identity: "Identité",
      client: "Client",
      metadata: "Métadonnées",
      security_code: "Code de sécurité",
      security: "Sécurité",
      assignment: "Assignation actuelle",
      notes: "Notes",
    },

    fields: {
      code: "Code",
      name: "Nom",
      security_code: "Code de sécurité",
      effective_security_code: "Code de sécurité effectif",
      status: "Statut",
      notes: "Notes",
      client_id: "Client",
      created_at: "Créé le",
      updated_at: "Modifié le",
      client: {
        name: "Client",
      },
      currentAssignment: {
        user: {
          display_name: "Assigné à",
        },
        assigned_at: "Assigné le",
      },
    },

    badges: {
      active: "Actif",
      lost: "Perdu",
      deactivated: "Désactivé",
    },

    filters: {
      status: "Statut",
      client_id: "Client",
    },

    options: {
      status: {
        active: "Actif",
        lost: "Perdu",
        deactivated: "Désactivé",
      },
    },

    actions: {
      assign: "Assigner",
      unassign: "Désassigner",
      assign_keys: "Assigner les clés",
      unassign_keys: "Désassigner les clés",
    },
  },
};
